var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGridviewGreen(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_72_71",
    "data-name": "Component 72 \\u2013 71",
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.813,
    height: 27.813,
    viewBox: "0 0 27.813 27.813",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #368c36;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_376",
    "data-name": "Path 376",
    className: "cls-1",
    d: "M6,18.748V6H18.748V18.748ZM6,33.813V21.066H18.748V33.813ZM21.066,18.748V6H33.813V18.748Zm0,15.066V21.066H33.813V33.813ZM8.318,16.43H16.43V8.318H8.318Zm15.066,0H31.5V8.318H23.383Zm0,15.066H31.5V23.383H23.383Zm-15.066,0H16.43V23.383H8.318Z",
    transform: "translate(-6 -6)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGridviewGreen);
export default __webpack_public_path__ + "static/media/GridviewGreen.4516d7d94d1eae7ddc6690ed384f9d7a.svg";
export { ForwardRef as ReactComponent };